import { MFButton } from "../../../../common/components/MFButton";
import MFModal from "../../../../common/containers/MFModal";

export function ModalNotDuplicableCalculs({
  isOpen,
  onClose,
  calculs,
  duplicateCalculs,
}) {
  const notDuplicableCalculs = (calculs || []).filter(
    (calcul) => !calcul.isDuplicable,
  );

  const validate = () => {
    duplicateCalculs();
    onClose();
  };

  return (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="calculs-not-duplicable"
    >
      <p className="modal-text" style={{ marginBottom: "20px" }}>
        En validant, les calculs suivant ne seront pas dupliqués, car ils
        appartiennent à une version antérieur et non compatible avec la version
        actuelle du calcul. Ainsi vous pouvez seulement visualiser vos
        paramètres de calcul et les résultats associés.
      </p>
      <div className="d-flex flex-column">
        {notDuplicableCalculs.map((calcul) => (
          <div
            className="calculs-not-duplicable-error-div"
            key={`not-duplicable-${calcul.id}`}
          >
            {calcul.name}
          </div>
        ))}
      </div>
      <div className="d-flex align-items-center justify-content-end mt-2">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton style={{ fontSize: 15 }} onClick={validate}>
          Valider
        </MFButton>
      </div>
    </MFModal>
  );
}
